module.exports = __webpack_public_path__ + "static/media/SOP_Mobile_External_French.de798413.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SOP_Mobile_External_French.pdf
// module id = 1497
// module chunks = 0